export default __webpack_public_path__ + "static/placement-do-dark-3d6ad8f8b7482f6e004fcf92b8b2cc7584f55a4b1d76ee0ef175f6bd932be81c.png";